<p-dialog
  [contentStyle]="{ overflow: 'inherit' }"
  header="{{'Crit_Srch' | translate}}"
  modal="modal"
  [(visible)]="visible"
  [closable]="true"
  (onHide)="closeDia($event)"
  [style]="{width: '50vw'}"
  >
  <div>
    <form [formGroup]="indexForm" class="grid form-group" novalidate>
      <div class="col-12">
        <span class="p-float-label size_cent">
          <input formControlName="Label" class="p-inputtext size_cent" pInputText type="text" />
          <label>{{'Index_B' | translate}} * ({{ name }})</label>
        </span>
      </div>
      <div class="col-12">
        <p-dropdown
          formControlName="NumOrder"
          autoWidth="false"
          [style]="{ width: '100%' }"
          (onChange)="onChange($event)"
          [options]="indexData.ListOrder"
          placeholder="{{'No_Sort' | translate}}"
          [(ngModel)]="selectedNumOrder"
        ></p-dropdown>
      </div>
      @if (selectedNumOrder != -1) {
        <div class="col-12 grid">
          <div class="col-6 p-field-radiobutton">
            <p-radioButton
              [disabled]="disabledTypeOrder"
              formControlName="TypeOrder"
              name="TypeOrder"
              value="0"
              [(ngModel)]="selectedOrder"
              inputId="optasc"
            ></p-radioButton>
            <label for="optasc" class="ml-2">{{'Sort_Asc' | translate}}</label>
          </div>
          <div class="col-6 p-field-radiobutton">
            <p-radioButton
              [disabled]="disabledTypeOrder"
              formControlName="TypeOrder"
              name="TypeOrder"
              value="1"
              [(ngModel)]="selectedOrder"
              inputId="optdesc"
            ></p-radioButton>
            <label for="optdesc" class="ml-2">{{'Sort_Dsc' | translate}}</label>
          </div>
        </div>
      }
      <div class="col-12">
        <p-checkbox
          formControlName="ThumbInfo"
          name="group2"
          binary="true"
          inputId="Includ_2"
        ></p-checkbox>
        <label for="Includ_2" class="ml-2">{{'Includ_2' | translate}}</label>
      </div>
    </form>
    <div class="col-12 md:col-12 align-right">
      <button class="margin p-button-primary p-button-outlined" type="button" pButton (click)="visible = false" label="{{'Cancel' | translate}}"></button>
      <button class="margin" type="button" pButton (click)="validItem()" label="{{'Valid' | translate}}"></button>
    </div>
  </div>
</p-dialog>
